import React from 'react';

const AWS_DynamoDB = () => {
  return (
    <div>
      <h1>AWS_DynamoDB</h1>
      <p>This is the AWS_DynamoDB component.</p>
    </div>
  );
};

export default AWS_DynamoDB;
